import React, { useState, useEffect } from "react";
import { Row, Col } from "react-bootstrap";
import ReactEcharts from "echarts-for-react";
import { useFormatter } from "./../../util/formatter";
import "./analytics.css";
import { useSolarCalc } from "../../util/calculations";

function AnalyticIndeGraphs(props) {
	const [formatNumber, isEmpty] = useFormatter();
	const [monthlyTargetConfig, setMonthlyTargetConfig] = useState(null);
	const [cumulativeTargetConfig, setCumulativeTargetConfig] = useState(null);
	const [dailyTargetConfig, setDailyTargetConfig] = useState(null);
	const [indeDataMonthly, setIndeDataMonthly] = useState(null);
	const [indeDataDaily, setIndeDataDaily] = useState(null);
	const [selectIrrad_DT, setSelectIrrad_DT] = useState(false);
	const [selectIrrad_MT, setSelectIrrad_MT] = useState(false);
	const [selectIrrad_CT, setSelectIrrad_CT] = useState(false);
	const solarCalc = useSolarCalc();

	/**
	 * Formula to calculate Performance Indice
	 * @param {Data object} obj
	 */
	// const calculatePIndice = (obj) =>
	// 	(obj.actualProd / obj.expProd - obj.actualIrr / obj.expIrr) * 100;

	/**
	 * Format tootips of graph
	 * @param {Graph parameter} params
	 */
	const formatterToolTip = (params) => {
		let PIndiceObj = {
			actualProd: null,
			expProd: null,
			actualIrr: null,
			expIrr: null,
		};
		let xx = "<p><b>" + params[0].axisValue + "</b></p>";
		const colorSpan = (color) =>
			'<span style="display:inline-block;margin-right:5px;border-radius:10px;width:9px;height:9px;background-color:' +
			color +
			'"></span>';
		params.map((item) => {
			xx += "<p>";
			xx += colorSpan(item.color);
			xx += item.seriesName + " : " + item.data;
			xx += "</p>";
			switch (item.seriesName) {
				case "Actual Production":
					PIndiceObj.actualProd = parseFloat(item.data);
					break;
				case "Expected Production":
					PIndiceObj.expProd = parseFloat(item.data);
					break;
				case "Actual Irradiation":
					PIndiceObj.actualIrr = parseFloat(item.data);
					break;
				case "Expected Irradiation":
					PIndiceObj.expIrr = parseFloat(item.data);
					break;

				default:
					break;
			}
		});

		const vals = Object.values(PIndiceObj);
		if (!vals.includes(null)) {
			const PI = formatNumber(solarCalc.calculatePIndice(PIndiceObj), 2);
			xx += "<hr style='padding:0; margin:10px 0'/>";
			xx += "<p>" + colorSpan("#fff") + "Performance Indice : " + PI + "%</p>";
		}
		return xx;
	};

	/**
	 * Update graph according to radio button selected
	 * @param {Selected radio button} selectRadio
	 * @param {Data} data
	 * @param {Process - MONTHLY / DAILY} process
	 */
	const updateSelect = (selectRadio, data, process) => {
		let data_gar = null;
		let data_exp = null;
		switch (process) {
			case "MONTHLY":
				data_gar = data.gar_target;
				data_exp = data.exp_target;
				break;
			case "DAILY":
				data_gar = data.tgp_cumul;
				data_exp = data.tep_cumul;
				break;

			default:
				break;
		}

		let selected = null;

		switch (selectRadio) {
			case "IRR":
				selected = {
					"Actual Production": false,
					"Guaranteed Production": false,
					"Expected Production": false,
				};
				break;
			case "PI":
				selected = {
					"Actual Production": true,
					"Guaranteed Production": false,
					"Expected Production": true,
					"Actual Irradiation": true,
					"Expected Irradiation": true,
				};
				break;

			default:
				selected = {
					"Actual Irradiation": false,
					"Expected Irradiation": false,
					"Actual Production": true,
					"Guaranteed Production":
						data != null && !verifyArr(data_gar) ? true : false,
					"Expected Production":
						data != null && !verifyArr(data_exp) ? true : false,
				};
				break;
		}
		return selected;
	};

	/**
	 *  Verify if elements of target data are all 0
	 * @param {Data array} arr
	 */
	const verifyArr = (arr) => arr.every((v) => v == arr[0] && v == 0);

	useEffect(() => {
		setIndeDataDaily(props.dataDaily);
	}, [props.dataDaily]);

	useEffect(() => {
		setIndeDataMonthly(props.dataMonthly);
	}, [props.dataMonthly]);

	useEffect(() => {
		if (indeDataDaily != null) {
			const selected = updateSelect(selectIrrad_DT, indeDataDaily, "DAILY");

			// Current Month Comparison
			const optionCurrentMonthTarget = {
				grid: {
					top: "20%",
				},
				color: ["#12a8e0", "#FF8500", "#ffc709", "#8dc63f", "#c23531"],
				tooltip: {
					trigger: "axis",
					axisPointer: {
						animation: true,
						type: "cross",
					},
					formatter: formatterToolTip,
				},
				legend: {
					data: [
						"Actual Production",
						"Guaranteed Production",
						"Expected Production",
						"Actual Irradiation",
						"Expected Irradiation",
					],
					top: "7%",
					selected: selected,
				},
				toolbox: {
					show: true,
					orient: "horizontal",
					right: "10%",
					feature: {
						saveAsImage: {
							show: true,
							title: "Download ",
						},
					},
				},
				dataZoom: [
					{
						type: "slider",
						filterMode: "filter",
					},
					{
						type: "inside",
						filterMode: "filter",
						realtime: true,
					},
				],
				xAxis: {
					type: "category",
					boundaryGap: false,
					axisTick: {
						alignWithLabel: true,
					},
					name: "Days",
					data: indeDataDaily.dates,
				},
				yAxis: [
					{
						type: "value",
						axisLabel: {
							formatter: "{value} kWh",
						},
						axisLine: { show: true },
						axisTick: {
							show: true,
						},
					},
					{
						type: "value",
						name: "Irradiation",
						axisLabel: {
							formatter: "{value} kWh/m\xB2",
						},
						axisLine: { show: true },
						axisTick: {
							show: true,
						},
					},
				],
				series: [
					{
						name: "Actual Production",
						type: "line",
						barGap: 0,
						lineStyle: {
							normal: {
								width: 1.2,
							},
						},
						symbolSize: 2,
						showSymbol: false,
						data: indeDataDaily.solar_cumul,
					},
					{
						name: "Guaranteed Production",
						type: "line",
						barGap: 0,
						lineStyle: {
							normal: {
								width: 1.2,
							},
						},
						symbolSize: 2,
						showSymbol: false,
						data: indeDataDaily.tgp_cumul,
					},
					{
						name: "Expected Production",
						type: "line",
						barGap: 0,
						lineStyle: {
							normal: {
								width: 1.2,
							},
						},
						symbolSize: 2,
						showSymbol: false,
						data: indeDataDaily.tep_cumul,
					},
					{
						name: "Actual Irradiation",
						type: "line",
						barGap: 0,
						yAxisIndex: 1,
						lineStyle: {
							normal: {
								width: 1.2,
							},
						},
						symbolSize: 2,
						showSymbol: false,
						data: indeDataDaily.irrad_cumul,
					},
					{
						name: "Expected Irradiation",
						type: "line",
						barGap: 0,
						yAxisIndex: 1,
						lineStyle: {
							normal: {
								width: 1.2,
							},
						},
						symbolSize: 2,
						showSymbol: false,
						data: indeDataDaily.irr_exp_cumul,
					},
				],
			};
			setDailyTargetConfig(optionCurrentMonthTarget);
		} else {
			setDailyTargetConfig(null);
		}
	}, [indeDataDaily, selectIrrad_DT]);

	useEffect(() => {
		if (indeDataMonthly != null) {
			const selected = updateSelect(selectIrrad_CT, indeDataMonthly, "MONTHLY");

			// Cumulative Comparison
			const optionCumulTarget = {
				grid: {
					top: "20%",
				},
				color: ["#12a8e0", "#FF8500", "#ffc709", "#8dc63f", "#c23531"],
				tooltip: {
					trigger: "axis",
					axisPointer: {
						animation: true,
						type: "cross",
					},
					formatter: formatterToolTip,
				},
				legend: {
					data: [
						"Actual Production",
						"Guaranteed Production",
						"Expected Production",
						"Actual Irradiation",
						"Expected Irradiation",
					],
					top: "7%",
					selected: selected,
				},
				toolbox: {
					show: true,
					orient: "horizontal",
					right: "10%",
					feature: {
						magicType: {
							show: true,
							title: {
								line: "Line",
								bar: "Bar",
							},
							type: ["line", "bar"],
							iconStyle: {
								textPosition: "top",
							},
						},
						restore: {
							show: true,
							title: "Restore ",
						},
						saveAsImage: {
							show: true,
							title: "Download ",
						},
					},
				},
				dataZoom: [
					{
						type: "slider",
						filterMode: "filter",
					},
					{
						type: "inside",
						filterMode: "filter",
						realtime: true,
					},
				],
				xAxis: [
					{
						type: "category",
						boundaryGap: false,
						axisTick: {
							alignWithLabel: true,
						},
						data: indeDataMonthly.months,
					},
				],
				yAxis: [
					{
						type: "value",
						axisLabel: {
							formatter: "{value} kWh",
						},
						axisLine: { show: true },
						axisTick: {
							show: true,
						},
					},
					{
						type: "value",
						name: "Irradiation",
						axisLabel: {
							formatter: "{value} kWh/m\xB2",
						},
						axisLine: { show: true },
						axisTick: {
							show: true,
						},
					},
				],
				series: [
					{
						name: "Actual Production",
						type: "line",
						barGap: 0,
						lineStyle: {
							normal: {
								width: 1.2,
							},
						},
						symbolSize: 2,
						showSymbol: false,
						data: indeDataMonthly.solar_cumul,
					},
					{
						name: "Guaranteed Production",
						type: "line",
						barGap: 0,
						lineStyle: {
							normal: {
								width: 1.2,
							},
						},
						symbolSize: 2,
						showSymbol: false,
						data: indeDataMonthly.gar_target_cumul,
					},
					{
						name: "Expected Production",
						type: "line",
						barGap: 0,
						lineStyle: {
							normal: {
								width: 1.2,
							},
						},
						symbolSize: 2,
						showSymbol: false,
						data: indeDataMonthly.exp_target_cumul,
					},
					{
						name: "Actual Irradiation",
						type: "line",
						barGap: 0,
						yAxisIndex: 1,
						lineStyle: {
							normal: {
								width: 1.2,
							},
						},
						symbolSize: 2,
						showSymbol: false,
						data: indeDataMonthly.irrad_cumul,
					},
					{
						name: "Expected Irradiation",
						type: "line",
						barGap: 0,
						yAxisIndex: 1,
						lineStyle: {
							normal: {
								width: 1.2,
							},
						},
						symbolSize: 2,
						showSymbol: false,
						data: indeDataMonthly.irrad_target_cumul,
					},
				],
			};
			setCumulativeTargetConfig(optionCumulTarget);
		} else {
			setCumulativeTargetConfig(null);
		}
	}, [indeDataMonthly, selectIrrad_CT]);

	useEffect(() => {
		if (indeDataMonthly != null) {
			const selected = updateSelect(selectIrrad_MT, indeDataMonthly, "MONTHLY");

			// Monthly Comparison
			const optionMonthlyTarget = {
				grid: {
					top: "20%",
				},
				color: ["#12a8e0", "#FF8500", "#ffc709", "#8dc63f", "#c23531"],
				tooltip: {
					trigger: "axis",
					axisPointer: {
						animation: true,
						type: "cross",
					},
					formatter: formatterToolTip,
				},

				legend: {
					data: [
						"Actual Production",
						"Guaranteed Production",
						"Expected Production",
						"Actual Irradiation",
						"Expected Irradiation",
					],
					top: "7%",
					selected: selected,
				},
				toolbox: {
					show: true,
					orient: "horizontal",
					right: "10%",
					feature: {
						magicType: {
							show: true,
							title: {
								line: "",
								bar: "",
							},
							type: ["line", "bar"],
							iconStyle: {
								textPosition: "top",
							},
						},
						restore: {
							show: true,
							title: " ",
						},
						saveAsImage: {
							show: true,
							title: " ",
						},
					},
				},
				xAxis: [
					{
						type: "category",
						axisTick: {
							alignWithLabel: true,
						},
						data: indeDataMonthly.months,
					},
				],
				yAxis: [
					{
						type: "value",
						name: "Energy",
						axisLabel: {
							formatter: "{value} kWh",
						},
						axisLine: { show: true },
						axisTick: {
							show: true,
						},
					},
					{
						type: "value",
						name: "Irradiation",
						axisLabel: {
							formatter: "{value} kWh/m\xB2",
						},
						axisLine: { show: true },
						axisTick: {
							show: true,
						},
					},
				],
				series: [
					{
						name: "Actual Production",
						type: "bar",
						barGap: 0,
						lineStyle: {
							normal: {
								width: 1.2,
							},
						},
						symbolSize: 2,
						showSymbol: false,
						data: indeDataMonthly.solar,
					},
					{
						name: "Guaranteed Production",
						type: "bar",
						barGap: 0,
						lineStyle: {
							normal: {
								width: 1.2,
							},
						},
						symbolSize: 2,
						showSymbol: false,
						data: indeDataMonthly.gar_target,
					},
					{
						name: "Expected Production",
						type: "bar",
						barGap: 0,
						lineStyle: {
							normal: {
								width: 1.2,
							},
						},
						symbolSize: 2,
						showSymbol: false,
						data: indeDataMonthly.exp_target,
					},
					{
						name: "Actual Irradiation",
						type: "bar",
						barGap: 0,
						yAxisIndex: 1,
						lineStyle: {
							normal: {
								width: 1.2,
							},
						},
						symbolSize: 2,
						showSymbol: false,
						data: indeDataMonthly.irr,
					},
					{
						name: "Expected Irradiation",
						type: "bar",
						barGap: 0,
						yAxisIndex: 1,
						lineStyle: {
							normal: {
								width: 1.2,
							},
						},
						symbolSize: 2,
						showSymbol: false,
						data: indeDataMonthly.irr_target,
					},
				],
			};
			setMonthlyTargetConfig(optionMonthlyTarget);
		} else {
			setMonthlyTargetConfig(null);
		}
	}, [indeDataMonthly, selectIrrad_MT]);

	return (
		<>
			<Row>
				{monthlyTargetConfig != null && (
					<Col xs={12} md={12} className="graph-container">
						<h4 className="graphHeader">Monthly Comparison</h4>
						<ReactEcharts
							style={{
								height: "600px",
								padding: "20px 0px 20px 0px",
								width: "80%",
								margin: "auto",
							}}
							option={monthlyTargetConfig}
							notMerge={true}
							lazyUpdate={true}
						/>

						<Row>
							<Col>
								<form className="centralised">
									<fieldset>
										<label className="radioLabel">
											<input
												className="radioSelect radioInput"
												name="selectRadio"
												type="radio"
												value="select"
												defaultChecked
												onChange={() => {
													setSelectIrrad_MT("PROD");
												}}
												// checked={!selectAll}
											/>{" "}
											<p className="radioSelect radioText">Production</p>
										</label>
										<label className="radioLabel">
											<input
												className="radioSelect radioInput"
												name="selectRadio"
												type="radio"
												value="select"
												onChange={() => {
													setSelectIrrad_MT("IRR");
												}}
												// checked={selectAll}
											/>
											<p className="radioSelect radioText">Irradiation</p>{" "}
										</label>
										<label className="radioLabel">
											<input
												className="radioSelect radioInput"
												name="selectRadio"
												type="radio"
												value="select"
												onChange={() => {
													setSelectIrrad_MT("PI");
												}}
												// checked={selectAll}
											/>
											<p className="radioSelect radioText">
												Show Performance Indice
											</p>{" "}
										</label>
									</fieldset>
								</form>
							</Col>
						</Row>
					</Col>
				)}
			</Row>
			<Row>
				{cumulativeTargetConfig != null && (
					<Col xs={12} md={12} className="graph-container">
						<h4 className="graphHeader">Cumulative Comparison</h4>
						<ReactEcharts
							style={{
								height: "600px",
								padding: "20px 0px 20px 0px",
								width: "80%",
								margin: "auto",
							}}
							option={cumulativeTargetConfig}
							notMerge={true}
							lazyUpdate={true}
						/>

						<Row>
							<Col>
								<form className="centralised">
									<fieldset>
										<label className="radioLabel">
											<input
												className="radioSelect radioInput"
												name="selectRadio"
												type="radio"
												value="select"
												defaultChecked
												onChange={() => {
													setSelectIrrad_CT("PROD");
												}}
												// checked={!selectAll}
											/>{" "}
											<p className="radioSelect radioText">Production</p>
										</label>
										<label className="radioLabel">
											<input
												className="radioSelect radioInput"
												name="selectRadio"
												type="radio"
												value="select"
												onChange={() => {
													setSelectIrrad_CT("IRR");
												}}
												// checked={selectAll}
											/>
											<p className="radioSelect radioText">Irradiation</p>{" "}
										</label>
										<label className="radioLabel">
											<input
												className="radioSelect radioInput"
												name="selectRadio"
												type="radio"
												value="select"
												onChange={() => {
													setSelectIrrad_CT("PI");
												}}
												// checked={selectAll}
											/>
											<p className="radioSelect radioText">
												Show Performance Indice
											</p>{" "}
										</label>
									</fieldset>
								</form>
							</Col>
						</Row>
					</Col>
				)}
			</Row>
			<Row>
				{dailyTargetConfig != null && (
					<Col xs={12} md={12} className="graph-container">
						<h4 className="graphHeader">Current Month Comparison</h4>
						<ReactEcharts
							style={{
								height: "600px",
								padding: "20px 0px 20px 0px",
								width: "80%",
								margin: "auto",
							}}
							option={dailyTargetConfig}
							notMerge={true}
							lazyUpdate={true}
						/>
						<Row>
							<Col>
								<form className="centralised">
									<fieldset>
										<label className="radioLabel">
											<input
												className="radioSelect radioInput"
												name="selectRadio"
												type="radio"
												value="select"
												defaultChecked
												onChange={() => {
													setSelectIrrad_DT("PROD");
												}}
											/>{" "}
											<p className="radioSelect radioText">Production</p>
										</label>
										<label className="radioLabel">
											<input
												className="radioSelect radioInput"
												name="selectRadio"
												type="radio"
												value="select"
												onChange={() => {
													setSelectIrrad_DT("IRR");
												}}
											/>
											<p className="radioSelect radioText">Irradiation</p>{" "}
										</label>
										<label className="radioLabel">
											<input
												className="radioSelect radioInput"
												name="selectRadio"
												type="radio"
												value="select"
												onChange={() => {
													setSelectIrrad_DT("PI");
												}}
											/>
											<p className="radioSelect radioText">
												Show Performance Indice
											</p>{" "}
										</label>
									</fieldset>
								</form>
							</Col>
						</Row>
					</Col>
				)}
			</Row>
		</>
	);
}

export default AnalyticIndeGraphs;
